/**
 * Convention: a paragraph break ("\n\n") at the top of a question label means
 * "render the part before the break as a section header above the field, and
 * the part after as the field's actual label."
 *
 * Used by F&P's multi-part SMCR questions (e.g. the (a)/(b)/(c)/(d) sub-parts
 * of the "professional dismissals" question all share an intro line). Also
 * available to any client-authored questionnaire template (Custom
 * Questionnaire / Tenancy) since the renderers are shared.
 *
 * Both the applicant flow (`CustomQuestionnaireField`) and the admin
 * settings preview (`CustomTemplateQuestionPreview`) call this so that
 * what an admin sees on the settings page matches what an applicant
 * sees in the form.
 *
 * Trade-off: this is a string convention rather than a real header field on
 * the question model. If we add a third template-driven check that wants
 * grouped sub-questions, consider promoting it to a first-class
 * `header` (or `description`) field on QuestionnaireQuestion and plumbing it
 * through the API + frontend properly.
 */
const HEADER_SEPARATOR = "\n\n";

export function splitLabelHeader(label: string | undefined): {
  header: string | null;
  fieldLabel: string;
} {
  if (!label) {
    return { header: null, fieldLabel: label ?? "" };
  }

  const separatorIndex = label.indexOf(HEADER_SEPARATOR);
  if (separatorIndex === -1) {
    return { header: null, fieldLabel: label };
  }

  return {
    header: label.slice(0, separatorIndex).trim(),
    fieldLabel: label.slice(separatorIndex + HEADER_SEPARATOR.length).trim(),
  };
}
